// @flow
import type { Node } from 'react';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { Badge, UncontrolledTooltip } from 'reactstrap';
import { badge, pending } from './index.module.scss';

type Props = {|
  className?: string | null,
  count?: number,
  level?: string,
  visible?: boolean,
|};

const SidebarBadge = ({
  className = null,
  count = 0,
  level = 'error',
  visible = true,
}: Props): Node => {
  const badgeRef = useRef(null);
  const color = { warning: 'warning', pending: 'info' }[level] || 'danger';
  // Pending counts are SP3-AI inputs waiting for review; say so on hover and to screen readers.
  const label =
    level === 'pending' ? `${count} SP3-AI input${count === 1 ? '' : 's'} to review` : null;

  if (!visible) {
    return null;
  }

  return (
    <>
      <Badge
        innerRef={badgeRef}
        className={classNames(badge, { [pending]: level === 'pending' }, className)}
        color={color}
        role={label ? 'img' : undefined}
        aria-label={label}
      >
        {count}
      </Badge>
      {label && (
        // Measured against the window, not the sidebar's own scroll box: inside the narrow
        // sidebar there is never room on the right, so the tooltip would flip left over the
        // section name. Rendered in <body> so the sidebar's overflow can't clip it.
        <UncontrolledTooltip
          target={badgeRef}
          placement="right"
          boundariesElement="window"
          container="body"
          delay={{ show: 100, hide: 0 }}
        >
          {label}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default SidebarBadge;
